import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../../components/layout";
import { useNavigate, useParams } from "react-router-dom";
import {
  Breadcrumbs,
  Button,
  Modal,
  RadioButtonList,
  Textfield,
} from "../../../../components/core";
import { pageListArray } from "../../user-access-permission/lists";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Strings } from "../../../../constants/strings";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_OPERATOR_ACCOUNT_ROLE,
  OPERATOR_ACCOUNT_ROLE_BY_ID,
  UPDATE_MULTIPLE_OPERATOR_ACCOUNT_ROLE,
  UPDATE_OPERATOR_ACCOUNT_ROLE,
} from "../../../../constants/graphql/operator_account_roles";
import { useSelector } from "react-redux";
import useSidebarStore from "../../../../zustand/stores/sidebar-store";
import { OPERATOR_ACCOUNTS_BY_FILTER } from "../../../../constants/graphql/auth-queries";
import { Dialog } from "primereact/dialog";
import { QUERY_Wallet_Operator } from "../../../../constants/graphql/drop-off-graphql";
import { sidebar } from "../../../../constants/sidebar";

const breadcrumbItems = [
  { label: "Roles and Template", path: `/roles-and-templates/` },
  { label: "Edit Template", path: "#" },
];
export default function EditTemplate() {
  const navigate = useNavigate();
  const { operatorAccountRoleId } = useParams();
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;

  // state
  const [searchCriteria, setSearchCriteria] = React.useState({
    operatorAccountRoleId: operatorAccountRoleId,
    roleName: "",
    accessPermissions: "",
  });
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const [confirmationAccountDialog, setConfirmationAccountDialog] =
    useState(false);
  const [accountsList2, setAccountsList2] = useState([]);
  const [isAllClciked, setIsAllClicked] = useState(false);
  const [confirmationDialogV2, setConfirmationDialogV2] = useState({
    openUpdateAll: false,
    openRoleOnly: false,
  });
  const [triggerUpdate, setTriggerUpdate] = useState(false);

  const [changesMade, setChangesMade] = useState(false);
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const localAccessedSidebar = useSidebarStore(
    (state) => state.localAccessedSidebar
  );
  const [pageGroup, setPageGroup] = React.useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [pageList, setPageList] = React.useState([]);
  const [parsedParentPermission, setParsedParentPermission] = useState();
  const [finalParentPermissionMapped, setFinalParentPermissionMapped] =
    useState();
  //gql
  const [updateOperatorAccountRole] = useMutation(
    UPDATE_OPERATOR_ACCOUNT_ROLE,
    { fetchPolicy: "no-cache" }
  );
  // Query to get operator access permissions
  const { data: findOperatorAccessPermission } = useQuery(
    QUERY_Wallet_Operator,
    {
      variables: { operatorId: operatorId },
    }
  );
  const operatorAccountRoleById = useQuery(OPERATOR_ACCOUNT_ROLE_BY_ID, {
    variables: { operatorAccountRoleId: operatorAccountRoleId },
    fetchPolicy: "no-cache",
  });
  const [updateMultipleOperatorAccountRole] = useMutation(
    UPDATE_MULTIPLE_OPERATOR_ACCOUNT_ROLE,
    { fetchPolicy: "no-cache" }
  );
  const { data: accountsList } = useQuery(OPERATOR_ACCOUNTS_BY_FILTER, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",

      operatorAccountRoleId: parseInt(operatorAccountRoleId),
    },
  });

  console.log({ accountsList });

  // test onle
  const transformSidebarToPageList = (sidebar) => {
    return sidebar.flatMap((section) => {
      // Convert main section pages
      const mainPages = section.content.map((item) => ({
        name: item.title,
        group: section.title.toLowerCase().replaceAll(" ", "-"),
        value: item.tag,
        permissions: [
          { id: "0", text: "No Access", checked: false },
          { id: "1", text: "Read Only", checked: false },
          { id: "2", text: "Read & Write", checked: false },
          {
            id: "5",
            text: "Read, write and approve/reject",
            checked: false,
          },
        ],
      }));

      // Convert subpages independently (flattened structure)
      const subPages = section.content.flatMap(
        (item) =>
          item.content?.map((subItem) => ({
            name: subItem.title,
            group: section.title.toLowerCase().replaceAll(" ", "-"),
            value: subItem.tag,
            permissions: [
              { id: "0", text: "No Access", checked: false },
              { id: "1", text: "Read Only", checked: false },
              { id: "2", text: "Read & Write", checked: false },
              {
                id: "5",
                text: "Read, write and approve/reject",
                checked: false,
              },
            ],
          })) || []
      );

      return [...mainPages, ...subPages];
    });
  };

  useEffect(() => {
    if (triggerUpdate) {
      handleSaveChanges();
      setTriggerUpdate(false); // Reset trigger
    }
  }, [isAllClciked, triggerUpdate]);

  console.log({ localAccessedSidebar });
  useEffect(() => {
    const permissionString = localStorage.getItem("permission");
    const parentAccessPermission = permissionString
      ? JSON.parse(permissionString)
      : {};
    setParsedParentPermission(parentAccessPermission);

    if (localAccessedSidebar?.length > 0) {
      const updatedPageList = transformSidebarToPageList(localAccessedSidebar);
      const filteredData = updatedPageList.filter(
        (item) => !Array.isArray(item.value)
      );

      console.log({ updatedPageList, filteredData });

      setPageList(filteredData);

      // Initialize pageGroup based on accessible pages
      const accessibleGroups = filteredData.reduce((acc, page) => {
        const groupExists = acc.find((group) => group.value === page.group);
        if (!groupExists) {
          const defaultPermission = page.permissions.find(
            (perm) => perm.checked
          ) || { id: "0" }; // Default to No Access
          acc.push({ value: page.group, checked: defaultPermission.id });
        }
        return acc;
      }, []);

      setPageGroup(accessibleGroups);
    }
  }, [localAccessedSidebar]);

  console.log({ pageGroup, pageList });

  // handle changes
  const handleOnGroupCheckChange = (event) => {
    const { name, id } = event.target;
    const groupName = name.split("hello")[0];
    const parentPermissionMap = {};
    const pagesInGroup = pageList.filter((page) => page.group === groupName);

    setChangesMade(true);
    let canAssignPermission = true;

    console.log({ pagesInGroup });
    // Check parent permissions for all pages in this group
    for (const page of pagesInGroup) {
      let parentPermissionLevel;

      if (Array.isArray(page.value)) {
        // Get the max permission level from array values
        parentPermissionLevel = Math.max(
          ...page.value.map((val) =>
            parseInt(parsedParentPermission[val] || "0")
          )
        );
      } else {
        parentPermissionLevel = parseInt(
          parsedParentPermission[page.value] || "0"
        );
      }
      parentPermissionMap[page.value] = parentPermissionLevel;

      console.log({ INSIDE_ONCHANGE: parentPermissionMap });
      // Restrict permission assignment if it exceeds parent’s permission
      if (
        parseInt(id) !== "3" &&
        parseInt(id) !== 3 &&
        parseInt(id) > parentPermissionLevel
      ) {
        canAssignPermission = false;
        break;
      }
    }

    // Prevent assignment if permission level is too high
    if (!canAssignPermission) {
      alert("You cannot assign a higher permission level than what you have.");
      return;
    }

    // Update `pageGroup`
    let tempPageGroup = [...pageGroup];
    const groupIndex = tempPageGroup.findIndex((x) => x.value === groupName);
    if (groupIndex !== -1) {
      tempPageGroup[groupIndex] = { ...tempPageGroup[groupIndex], checked: id };
      setPageGroup(tempPageGroup);
    }

    // Update `pageList` permissions
    let updatedPageList = pageList.map((page) => {
      if (page.group === groupName) {
        return {
          ...page,
          permissions: page.permissions.map((permission) => {
            if (id === "3") {
              return { ...permission, checked: false };
            } else {
              return { ...permission, checked: permission.id === id };
            }
          }),
        };
      }
      return page; // Leave other pages unchanged
    });

    setFinalParentPermissionMapped(parentPermissionMap);
    setPageList(updatedPageList);
  };

  // validation
  const validateFields = () => {
    // Check for invalid states
    const invalidGroups = pageGroup.filter((group) => {
      if (group.checked === "3") {
        // Find corresponding pages in pageList
        const relatedPages = pageList.filter(
          (page) => page.group === group.value
        );

        // Check if all permissions in related pages are unchecked
        return relatedPages.every((page) =>
          page.permissions.every((permission) => !permission.checked)
        );
      }
      return false;
    });

    // If invalid groups exist, show an error message and exit
    if (invalidGroups.length > 0) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Error",
        message:
          "Some groups are marked as 'Custom assign' but have no permissions checked.",
        open: true,
        actions: (
          <div className="gap-2 w-full mx-auto">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return;
    }

    if (!searchCriteria.roleName) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title,
        message: Strings.popup_error_title_empty_field,
        open: true,
        actions: (
          <div className="gap-2 w-full mx-auto">
            <Button
              onClick={() => {
                setValidation({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } else {
      // handleSaveChanges();
      if (accountsList2 && accountsList2.length === 0) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          title: Strings.popup_confirm_save_title,
          message: Strings.popup_confirm_save_massage,
          open: true,
          actions: (
            <div className="grid grid-cols-2 gap-2">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"No"}
                className={"p-2"}
              />
              <Button
                onClick={handleSaveChanges}
                value={"Yes"}
                className={"p-2"}
              />
            </div>
          ),
        });
      } else {
        setConfirmationAccountDialog(true);
      }
    }
  };

  const handleSaveChanges = () => {
    let tempObj = {};
    pageList.forEach((data, index) => {
      data.permissions.forEach((item, i) => {
        if (item.checked === true) {
          tempObj[data.value] = item.id;
        }
      });
    });
    let tempSearchCriteria = { ...searchCriteria };
    tempSearchCriteria.accessPermissions = JSON.stringify(tempObj);
    tempSearchCriteria.updateAccounts = isAllClciked;

    console.log(tempSearchCriteria);
    updateOperatorAccountRole({
      variables: {
        input: tempSearchCriteria,
      },
    })
      .then((data) => {
        console.log(data);

        // close all dialogs to avoid reclicking
        setConfirmationDialogV2({
          ...confirmationDialogV2,
          openRoleOnly: false,
          openUpdateAll: false,
        });
        setConfirmationAccountDialog(false);

        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          title: Strings.popup_success_message_edit,
          message: Strings.popup_success_message_edit,
          open: true,
          actions: (
            <div className="gap-2 w-full mx-auto">
              <Button
                onClick={() => {
                  setValidation({ open: false });

                  window.location.reload();
                }}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
        // updateMultipleOperatorAccountRole({
        //   variables: {
        //     operatorId: JSON.parse(localStorage.getItem("user")).operator_id,
        //     operatorAccountRoleId: tempSearchCriteria.operatorAccountRoleId,
        //     accessPermissions: tempSearchCriteria.accessPermissions,
        //   },
        // })
        //   .then((data) => {
        //     console.log(data);
        //   })
        //   .catch((e) => console.log(e));
      })
      .catch((e) => {
        console.log(e);
      });
  };
  // use effects
  React.useEffect(() => {
    if (operatorAccountRoleById.data) {
      let roleData = {
        ...operatorAccountRoleById.data.operatorAccountRoleById,
      };
      delete roleData.__typename;
      setSearchCriteria(roleData);
    }
  }, [operatorAccountRoleById.data]);

  useEffect(() => {
    if (
      operatorAccountRoleById?.data?.operatorAccountRoleById &&
      pageList.length > 0
    ) {
      const accessPermissions =
        operatorAccountRoleById.data.operatorAccountRoleById.accessPermissions;

      if (accessPermissions !== "") {
        const parsedPermissions = JSON.parse(accessPermissions);

        let tempPageList = [...pageList];

        // Update pageList permissions based on parsedPermissions
        tempPageList.forEach((page, pageIndex) => {
          Object.entries(parsedPermissions).forEach(
            ([pageValue, permissionId]) => {
              if (page.value === pageValue) {
                page.permissions.forEach((permission, permissionIndex) => {
                  // Compare id and set the checked value accordingly
                  tempPageList[pageIndex].permissions[permissionIndex].checked =
                    JSON.stringify(permission.id) ===
                    JSON.stringify(permissionId);
                });
              }
            }
          );
        });

        // Update pageGroup to reflect the current state
        const updatedPageGroup = pageGroup.map((group) => {
          const groupPages = tempPageList.filter(
            (page) => page.group === group.value
          );

          if (groupPages.length > 0) {
            const allNoAccess = groupPages.every((page) =>
              page.permissions.some(
                (permission) => permission.checked && permission.id === "0"
              )
            );
            const allReadOnly = groupPages.every((page) =>
              page.permissions.some(
                (permission) => permission.checked && permission.id === "1"
              )
            );
            const allReadWrite = groupPages.every((page) =>
              page.permissions.some(
                (permission) => permission.checked && permission.id === "2"
              )
            );

            let checkedValue = "3";
            if (allNoAccess) {
              checkedValue = "0";
            } else if (allReadOnly) {
              checkedValue = "1";
            } else if (allReadWrite) {
              checkedValue = "2";
            }

            return { ...group, checked: checkedValue };
          } else {
            return group;
          }
        });

        setPageList(tempPageList);
        setPageGroup(updatedPageGroup);
      }
    }
  }, [operatorAccountRoleById.data, pageList.length]);

  useEffect(() => {
    // console.log("Effect triggered:", {
    // 	pendingNavigationHere,
    // 	changesMade,
    // 	currentPath: location.pathname,
    // });
    if (pendingNavigation !== null) {
      if (changesMade) {
        // setCancelDialogOpen(true);
        console.log("open dialog");
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  // window.location.reload();
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  useEffect(() => {
    if (accountsList && accountsList.operatorAccountsByFilter) {
      const operatorAccounts = accountsList.operatorAccountsByFilter.map(
        (operator) => ({
          username: operator.username,
          userEmail: operator.userEmail,
          operatorAccountId: operator.operatorAccountId,
        })
      );

      console.log({ accountsList });
      setAccountsList2(operatorAccounts);
    }
  }, [accountsList]);

  console.log({ searchCriteria });
  return (
    <>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer containerTitle={"EDIT TEMPLATE"} className={"w-full"}>
        <div className="grid grid-cols-2 gap-2 w-1/3 my-4">
          <p className="my-auto">Operator:</p>
          <p className="font-bold">
            {JSON.parse(localStorage.getItem("user")).company}
          </p>
          <p className="my-auto">Role Name:</p>
          <Textfield
            disabled={
              accessPermission.rolesAndTemplates === 1 ||
              accessPermission.rolesAndTemplates === "1"
            }
            placeholder={"Enter role name"}
            maxLength={64}
            name={"roleName"}
            value={searchCriteria.roleName}
            onChange={(e) =>
              setSearchCriteria((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
          />
        </div>
        <table className="w-3/4 border">
          <tbody>
            {pageGroup.map((group, key) => {
              return (
                <tr className="w-full">
                  <td
                    className="border border-secondary-darkGray w-full"
                    colSpan={2}
                  >
                    {/* <p
												className="uppercase cursor-pointer"
												onClick={() => setIsOpen(!isOpen)}
											>
												{data}
											</p>
											{isOpen && <div>{""}</div>} */}
                    <Accordion style={{ width: "100%" }} activeIndex={0}>
                      <AccordionTab
                        headerClassName="w-full"
                        header={group.value.toUpperCase().replaceAll("-", " ")}
                        style={{ width: "100%" }}
                      >
                        {/* AccordionTab content goes here */}
                        <label className=" items-start space-x-2 p-1 flex mt-4">
                          <input
                            type="radio"
                            disabled={
                              accessPermission.rolesAndTemplates === 1 ||
                              accessPermission.rolesAndTemplates === "1"
                            }
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "0"}
                            id={"0"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">Set all to no access</span>
                        </label>
                        <label className=" items-start space-x-2 p-1 flex">
                          <input
                            type="radio"
                            disabled={
                              accessPermission.rolesAndTemplates === 1 ||
                              accessPermission.rolesAndTemplates === "1"
                            }
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "1"}
                            id={"1"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">Set all to read only</span>
                        </label>
                        <label className=" items-start space-x-2 p-1 flex">
                          <input
                            type="radio"
                            disabled={
                              accessPermission.rolesAndTemplates === 1 ||
                              accessPermission.rolesAndTemplates === "1"
                            }
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "2"}
                            id={"2"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">
                            Set all to read and write
                          </span>
                        </label>

                        <label className=" items-start space-x-2 p-1 flex">
                          <input
                            type="radio"
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "5"}
                            id={"5"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">
                            Set all to read, write, & accept/reject
                          </span>
                        </label>

                        <label className=" items-start space-x-2 p-1 flex mb-4">
                          <input
                            type="radio"
                            disabled={
                              accessPermission.rolesAndTemplates === 1 ||
                              accessPermission.rolesAndTemplates === "1"
                            }
                            name={group.value + "hello"}
                            className="form-radio h-5 w-5 text-blue-600 my-auto"
                            checked={group.checked === "3"}
                            id={"3"}
                            onChange={handleOnGroupCheckChange}
                          />
                          <span className="my-auto">Custom assign</span>
                        </label>

                        <table className="w-[90%] border-collapse border border-secondary-darkGray">
                          <tbody>
                            {pageList.map((data, key) => {
                              if (data.group === group.value)
                                return (
                                  <tr key={key} className="w-full">
                                    <td className="p-2 border border-secondary-darkGray w-2/4 ">
                                      <p>{data.name}</p>
                                    </td>
                                    <td className="p-2 border border-secondary-darkGray">
                                      <div className="flex justify-center">
                                        <RadioButtonList
                                          disabled={
                                            pageGroup.find(
                                              (x) => x.value === data.group
                                            )?.checked !== "3" ||
                                            accessPermission.rolesAndTemplates ===
                                              1 ||
                                            accessPermission.rolesAndTemplates ===
                                              "1"
                                          }
                                          dataItems={data.permissions}
                                          name={data.value}
                                          handleChange={(e) => {
                                            const selectedPermission =
                                              parseInt(e);

                                            let parentPermissionLevel;
                                            if (Array.isArray(data.value)) {
                                              parentPermissionLevel = Math.max(
                                                ...data.value.map((val) =>
                                                  parseInt(
                                                    parsedParentPermission[
                                                      val
                                                    ] || "0"
                                                  )
                                                )
                                              );
                                            } else {
                                              parentPermissionLevel = parseInt(
                                                parsedParentPermission[
                                                  data.value
                                                ] || "0"
                                              );
                                            }

                                            console.log({
                                              parentPermissionLevel,
                                            });

                                            if (
                                              selectedPermission >
                                              parentPermissionLevel
                                            ) {
                                              alert(
                                                "You cannot assign a higher permission level than what you have."
                                              );
                                              return;
                                            }

                                            setChangesMade(true);

                                            // Find the ACTUAL index in pageList using data.value
                                            const actualIndex =
                                              pageList.findIndex(
                                                (page) =>
                                                  page.value === data.value
                                              );

                                            let tempArr = [...pageList];
                                            tempArr[actualIndex].permissions =
                                              tempArr[
                                                actualIndex
                                              ].permissions.map(
                                                (permission) => ({
                                                  ...permission,
                                                  checked: permission.id === e,
                                                })
                                              );
                                            setPageList(tempArr);
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                            })}
                          </tbody>
                        </table>
                      </AccordionTab>
                    </Accordion>
                  </td>
                  {/* <td className="p-2 border border-secondary-darkGray">
										<div>
											<MultiStateCheckboxes
												className={"w-full"}
												onChange={(e) => {
													console.log(
														permissionList[pageAccessList[data.value]]
													);
													setPageAccessList((prev) => ({
														...prev,
														[data.value]: e.value ? e.value : "0",
													}));
												}}
												value={pageAccessList[data.value]}
												options={permissions}
												noValue="No Access Permission"
												currentValue={
													permissionList[pageAccessList[data.value]]
														? permissionList[pageAccessList[data.value]]
														: "No Access Permission"
												}
											/>
											{}
										</div>
									</td> */}
                </tr>
              );
            })}
          </tbody>
        </table>

        <div
          className={`grid grid-cols-2 gap-2 w-1/3 my-4 ${
            accessPermission.rolesAndTemplates === 1 ||
            accessPermission.rolesAndTemplates === "1"
              ? "hidden"
              : ""
          }`}
        >
          <Button
            value={"Cancel"}
            className={"p-2"}
            onClick={() => {
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: Strings.popup_confirm_cancel_title,
                message: Strings.popup_confirm_cancel_massage,
                open: true,
                actions: (
                  <div className="grid grid-cols-2 gap-2">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"No"}
                      className={"p-2"}
                    />
                    <Button
                      onClick={() => {
                        navigate(`/roles-and-templates/`);
                      }}
                      value={"Yes"}
                      className={"p-2"}
                    />
                  </div>
                ),
              });
            }}
          />
          <Button
            value={"Save Changes"}
            disabled={!changesMade}
            className={"p-2"}
            onClick={validateFields}
          />
        </div>
        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />

        {/* {confirmationAccountDialog && ( */}
        <Dialog
          visible={confirmationAccountDialog}
          closable={false}
          resizable={false}
          draggable={false}
          className="w-[510px]"
          header={
            <div className="flex items-center gap-3">
              <div className="text-yellow-500">
                <i className="pi pi-exclamation-triangle text-2xl"></i>
              </div>
              <h3 className="text-lg font-medium">
                How would you like to proceed?
              </h3>
            </div>
          }
        >
          <div className="mt-2">
            <p className="mb-3 text-gray-700 ">
              The following accounts, which are under this role, will also be
              updated:
            </p>

            <div className="bg-gray-50 rounded-md p-2 mb-4">
              {accountsList2.map((account, index) => (
                <div
                  key={account.operatorAccountId}
                  className={`py-2 ${
                    index !== accountsList2.length - 1
                      ? "border-b border-gray-200"
                      : ""
                  }`}
                >
                  <div className="font-medium">{account.username}</div>
                  <div className="text-sm text-gray-500">
                    {account.userEmail}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex gap-3 mx-auto justify-center items-center mt-4">
              <button
                className={`bg-primary-primaryYellow text-black hover:bg-primary-primaryYellowDark px-4 py-2 rounded flex items-center gap-2 ${
                  isClicked
                    ? "opacity-50 cursor-not-allowed pointer-events-none"
                    : ""
                }`}
                disabled={isClicked}
                onClick={() => {
                  // transfer this two triggers to the confirmation dialog 2
                  setConfirmationDialogV2({
                    ...confirmationDialogV2,
                    openUpdateAll: true,
                  });
                }}
              >
                <i className="pi pi-check"></i>
                Update ALL accounts
              </button>
              <button
                className={`bg-white border border-primary-primaryYellow hover:bg-gray-50 px-4 py-2 rounded flex items-center gap-2 ${
                  isClicked
                    ? "opacity-50 cursor-not-allowed pointer-events-none"
                    : ""
                }`}
                onClick={() => {
                  setConfirmationDialogV2({
                    ...confirmationDialogV2,
                    openRoleOnly: true,
                  });
                }}
                disabled={isClicked}
              >
                <i className="pi pi-filter"></i>
                Update role only
              </button>
            </div>

            <div className="text-center mt-4">
              <button
                className={`text-primary-testBlue hover:text-blue-700 ${
                  isClicked
                    ? "opacity-50 cursor-not-allowed pointer-events-none"
                    : ""
                }`}
                onClick={() => {
                  setConfirmationAccountDialog(false);
                  setIsClicked(false);
                }}
                disabled={isClicked}
              >
                Close
              </button>
            </div>
          </div>
        </Dialog>

        {/* confirmation dialog for when you are updating the accounts associated with the role */}
        <Dialog
          visible={confirmationDialogV2.openUpdateAll}
          onHide={() => {
            setConfirmationDialogV2({
              ...confirmationDialogV2,
              openUpdateAll: false,
            });
          }}
          closable={false}
          draggable={false}
          resizable={false}
          className="w-[650px]"
          header={
            <div className="flex items-center gap-3">
              <div className="text-yellow-500">
                <i className="pi pi-exclamation-triangle text-2xl"></i>
              </div>
              <h3 className="text-lg font-medium">
                You're about to update the accounts under the role{" "}
                <b>{searchCriteria.roleName}</b>
              </h3>
            </div>
          }
        >
          <div className="text-center text-[19px]">
            Updating this role will apply changes to all associated accounts.
            Any custom permissions previously assigned to individual accounts
            will be overridden.
          </div>
          <div className="flex w-full justify-center mx-auto gap-2 pt-4">
            <Button
              value={"Cancel"}
              className={"p-2 bg-white border border-primary-primaryYellow"}
              onClick={() => {
                setConfirmationDialogV2({
                  ...confirmationDialogV2,
                  openUpdateAll: false,
                });
              }}
            />
            <Button
              value={"Update Role"}
              className={"p-2"}
              onClick={() => {
                setIsAllClicked(true);
                setTriggerUpdate(true);
              }}
            />
          </div>
        </Dialog>

        {/* confirmation dialog for when you are updating the role ONLY */}
        <Dialog
          visible={confirmationDialogV2.openRoleOnly}
          closable={false}
          draggable={false}
          resizable={false}
          className="w-[650px]"
          header={
            <div className="flex items-center gap-3">
              <div className="text-yellow-500">
                <i className="pi pi-exclamation-triangle text-2xl"></i>
              </div>
              <h3 className="text-lg font-medium">
                You're about to update the role <b>{searchCriteria.roleName}</b>
              </h3>
            </div>
          }
        >
          <div className="text-center text-[19px]">
            Updating this role will not affect existing associated accounts. Any
            custom permissions previously assigned to individual accounts will
            remain unchanged. The updated role permissions will only apply to
            new accounts moving forward.
          </div>
          <div className="flex w-full justify-center mx-auto gap-2 pt-4">
            <Button
              value={"Cancel"}
              className={"p-2 bg-white border border-primary-primaryYellow"}
              onClick={() => {
                setConfirmationDialogV2({
                  ...confirmationDialogV2,
                  openRoleOnly: false,
                });
              }}
            />
            <Button
              value={"Update Role"}
              className={"p-2"}
              onClick={() => {
                setIsAllClicked(false);
                setTriggerUpdate(true);
              }}
            />
          </div>
        </Dialog>
        {/* )} */}
      </ContentContainer>
    </>
  );
}
